import { useCallback, useState } from 'react';

// Map UX quest (2026-09-17). One-line hint next to the zoom readout. It goes
// away on the visitor's first click/drag/pinch on the map and stays away in
// that browser (localStorage). Wording is the founder's, verbatim.
export const MAP_HINT_STORAGE_KEY = 'mapHintDismissed';

export const MAP_HINT_TEXT = {
  farmers: 'Tap a marker to zoom in · tap a farmer to see their story',
  forests: 'Tap a marker to zoom in · tap a tree to see its photo',
} as const;

// Private-mode browsers can throw on localStorage: the hint then simply shows
// again next visit, which is harmless.
const readDismissed = () => {
  try {
    return window.localStorage.getItem(MAP_HINT_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const useMapHint = () => {
  const [dismissed, setDismissed] = useState(readDismissed);

  const dismiss = useCallback(() => {
    setDismissed(true);
    try {
      window.localStorage.setItem(MAP_HINT_STORAGE_KEY, '1');
    } catch {
      // see readDismissed
    }
  }, []);

  return { dismissed, dismiss };
};

export const MapHint = ({ variant }: { variant: keyof typeof MAP_HINT_TEXT }) => {
  return (
    <div
      data-testid="map-hint"
      style={{
        background: 'rgba(0,0,0,0.6)',
        color: 'white',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 12,
      }}
    >
      {MAP_HINT_TEXT[variant]}
    </div>
  );
};
